/**
 * 模組頁面代碼 : 1320-UI-01
 * 頁面說明 : 角色權限清單列表頁面
 * @module modules/role-permission/components/RolePermissionPage
 */

// ----- import from npm modules -----
import $ from 'jquery';

// ----- import from base libraries -----
import {
    React,
    PropTypes,
    BaseComponent,
    connect,
    AccessModeEnums,
    ModuleEnums,
} from '../../../components/BaseComponent';
import {
    DataTableComponent,
    batchCheckControls,
} from '../../../components/CommonComponent';

import { AlertModalModeEnums } from 'web/components/AlertModal';
import Breadcrumb from '../../../features/main-frame/components/Breadcrumb';

class RolePermissionPage extends BaseComponent {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.handleSearch = this.handleSearch.bind(this);
        this.prepareRolePermissionTable = this.prepareRolePermissionTable.bind(this);
        this.addEventListeners = this.addEventListeners.bind(this);
        this.onBatchHandle = this.onBatchHandle.bind(this);
    }

    prepareRolePermissionTable = () => {
        const { rolePermissionList } = this.props;

        // 定義資料內容
        const dataSet = rolePermissionList.map((rolePermission) => {
            return [
                rolePermission.roleName,
                rolePermission.moduleName,
                rolePermission.roleDescription,
                rolePermission.flgRead,
                rolePermission.flgCreate,
                rolePermission.flgUpdate,
                rolePermission.flgDelete,
                rolePermission.updateTime,
            ];
        });

        // 定義欄位屬性
        const columnConfig = [
            {
                orderable: false,
                order: null,
                title: '<div class="form-check"><input class="form-check-input" type="checkbox" value="" id="check-all" data-show-indeterminate="true"/><label class="form-check-label" for="check-all"></label></div>',
                data: null,
                render: function (data, type, row, meta) {
                    let checkboxId = 'cks-rolePerm-' + meta.row;
                    return `
                        <div class="form-check">
                            <input class="form-check-input item-cks-rolePerm" type="checkbox" value="" id="${checkboxId}" name="cks" />
                            <label class="form-check-label" for="${checkboxId}"></label>
                        </div>
                    `;
                },
                width: '5%',
            },
            { title: '角色類別', data: 0 },
            { title: '功能模組', className: 'dt-center', data: 1 },
            { title: '角色說明', className: 'dt-center', data: 2 },
            {
                orderable: false,
                title: '讀取',
                data: 3,
                render: function (data, type, row, meta) {
                    let perRId = 'perR-' + meta.row;
                    let isChecked = data === 1 ? 'checked' : ''
                    return `
                        <div class="form-check">
                            <input class="form-check-input read-only" type="checkbox" id="${perRId}" ${isChecked} disabled />
                            <label class="form-check-label" for="${perRId}"></label>
                        </div>
                    `;
                },
                width: '8%',
            },
            {
                orderable: false,
                title: '新增',
                data: 4,
                render: function (data, type, row, meta) {
                    let perCId = 'perC-' + meta.row;
                    let isChecked = data === 1 ? 'checked' : '';
                    return `
                        <div class="form-check">
                            <input class="form-check-input read-only" type="checkbox" id="${perCId}" ${isChecked} disabled />
                            <label class="form-check-label" for="${perCId}"></label>
                        </div>
                    `;
                },
                width: '8%',
            },
            {
                orderable: false,
                title: '修改',
                data: 5,
                render: function (data, type, row, meta) {
                    let perUId = 'perU-' + meta.row;
                    let isChecked = data === 1 ? 'checked' : '';
                    return `
                        <div class="form-check">
                            <input class="form-check-input read-only" type="checkbox" id="${perUId}" ${isChecked} disabled />
                            <label class="form-check-label" for="${perUId}"></label>
                        </div>
                    `;
                },
                width: '8%',
            },
            {
                orderable: false,
                title: '停用',
                data: 6,
                render: function (data, type, row, meta) {
                    let perDId = 'perD-' + meta.row;
                    let isChecked = data === 1 ? 'checked' : '';
                    return `
                        <div class="form-check">
                            <input class="form-check-input read-only" type="checkbox" id="${perDId}" ${isChecked} disabled />
                            <label class="form-check-label" for="${perDId}"></label>
                        </div>
                    `;
                },
                width: '8%',
            },
            { title: '修改時間', className: 'dt-head-center', data: 7, render: DataTable.render.datetime('YYYY-MM-DD HH:mm:ss'), type: 'datetime' },
            {
                orderable: false,
                order: null,
                data: null,
                className: 'dt-right',
                render: (data, type, row, meta) => {
                    let editId = 'edit-rolePerm-' + meta.row;
                    let deleId = 'dele-rolePerm-' + meta.row;
                    let updateButton = this.checkPermission(ModuleEnums.ROLE_PERMISSION, AccessModeEnums.UPDATE) ?
                        `<button type="button" class="btn btn-sm btn-link" id="${editId}">
                            <svg class="btn__icon btn__icon--sm me-1" aria-hidden="true">
                                <use href="#ico-edit"></use>
                            </svg>
                            修改
                        </button>` : '';
                    let deleteButton = this.checkPermission(ModuleEnums.ROLE_PERMISSION, AccessModeEnums.DELETE) ?
                        `<button type="button" class="btn btn-sm btn-link" id="${deleId}">
                            刪除
                        </button>` : '';
                    return `
                        <div class="btn-group" role="group" aria-label="">
                            ${updateButton}
                            ${deleteButton}
                        </div>`;
                },
            },
        ];

        // 定義排序設定
        const orderConfig = [
            [1, 'asc'],
            [2, 'asc'],
        ];

        // 定義固定欄位設定
        const fixedColumnsConfig = {
            start: 1,
        };

        // 先清除datatable
        if ($.fn.DataTable.isDataTable('#datatable__rolePermissionList')) {
            $('#datatable__rolePermissionList').DataTable().destroy();
        }

        // 重新繪製datatable
        DataTableComponent('#datatable__rolePermissionList', dataSet, columnConfig, orderConfig, fixedColumnsConfig, true, true);
        this.addEventListeners();
        batchCheckControls();
    }

    componentDidMount() {
        // 檢查權限
        this.checkPermission(ModuleEnums.ROLE_PERMISSION, AccessModeEnums.READ);
    }

    componentDidUpdate(prevProps) {
        const { needRolePermissionLoad, setNeedRolePermissionLoad, rolePermissionList } = this.props;

        if (needRolePermissionLoad && 
            needRolePermissionLoad !== prevProps.needRolePermissionLoad) {
            if (rolePermissionList.length > 0) {
                this.prepareRolePermissionTable();
            }
            setNeedRolePermissionLoad(false);
        }
    }

    handleSearch(e) {
        e.preventDefault();
        const searchForm = new FormData(e.target);
        const roleId = parseInt(searchForm.get('searchRoleSelection')? searchForm.get('searchRoleSelection') : 0);
        const moduleId = parseInt(searchForm.get('searchModuleSelection')? searchForm.get('searchModuleSelection') : 0);
        this.props.setSearchRolePermission(roleId, moduleId);
        this.props.fetchRolePermissionList(roleId, moduleId).then(() => {
            // Get data and redraw datatable
            this.prepareRolePermissionTable();
        });
    }

    addEventListeners() {
        if (this.tableRef.current) {
            this.tableRef.current.addEventListener('click', (event) => {
                const button = event.target.closest('.btn');
                if (button && button.id.startsWith('edit-rolePerm-')) {
                    this.props.onEditRolePermission(parseInt(button.id.split('-')[2]));
                }
                if (button && button.id.startsWith('dele-rolePerm-')) {
                    const delRolePermission = this.props.rolePermissionList[parseInt(button.id.split('-')[2])];
                    const permissionId = delRolePermission.permissionId;
                    const moduleName = delRolePermission.moduleName;
                    const message = `確定要刪除 [ ${moduleName} ] 模組權限資料嗎？`;
                    this.props.onDeleteRolePermission(message, permissionId);
                }
            });
        }
    }

    onBatchHandle(mode = AlertModalModeEnums.DELETE) {
        const permissionIds = [];
        const checkboxes = document.querySelectorAll('.item-cks-rolePerm');
        checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                const permissionId = this.props.rolePermissionList[parseInt(checkbox.id.split('-')[2])].permissionId;
                permissionIds.push(permissionId);
            }
        });
        // 如果沒有選擇任何資料就不處理
        if (permissionIds.length === 0) {
            return;
        }

        this.props.onBatchHandle(mode, permissionIds);      
    }

    render() {
        const { roleSelection, moduleSelection, onNewRolePermission, onRoleList } = this.props;
        return (
            <section id="datatable-container">
                <Breadcrumb categoryName="系統設定" pageName="角色權限" />
                <h4>角色權限</h4>
                <div className="datatable__search">
                    <form className="d-flex gap-2 align-items-end needs-validation" onSubmit={this.handleSearch}>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchRoleSelection" className="form-label">角色類別*</label>
                            <select className="form-select form-select-sm" id="searchRoleSelection" name="searchRoleSelection" required>
                                <option disabled value="">請選擇</option>
                                <option value="0">全部</option> 
                                {roleSelection.map((role, index) => (
                                    <option key={index} value={role.roleId}>{role.roleName}</option>
                                ))}
                            </select>
                        </div>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchModuleSelection" className="form-label">功能模組*</label>
                            <select className="form-select form-select-sm" id="searchModuleSelection" name="searchModuleSelection" required>
                                <option disabled value="">請選擇</option>
                                <option value="0">全部</option>
                                {moduleSelection.map((module, index) => (
                                    <option key={index} value={module.moduleId}>{module.moduleName}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <button 
                                className="btn btn-primary" 
                                type="submit"
                                aria-label="搜尋"
                            >
                                <svg className="btn__icon" aria-hidden="true">
                                    <use href="#ico-search"></use>
                                </svg>
                            </button>
                        </div>
                    </form>
                </div>
                <div className="datatable__tool">
                    <div className="d-flex align-items-center gap-2">
                        <div className="datatable__tool__label">
                            多筆選擇
                            <div id="checked-count-display"></div>
                        </div>
                        {this.checkPermission(ModuleEnums.ROLE_PERMISSION, AccessModeEnums.DELETE) && (
                        <div className="btn-group btn-group-sm" role="group" aria-label="">
                                <button type="button" className="btn btn-outline-secondary btn-batch" aria-label="刪除" id="btnBatchDelete" onClick={() => this.onBatchHandle(AlertModalModeEnums.DELETE)}>
                                    <svg className="btn__icon me-2" aria-hidden="true">
                                        <use href="#ico-trash"></use>
                                    </svg>
                                    刪除
                                </button>
                        </div>
                        )}
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        {this.checkPermission(ModuleEnums.ROLE, AccessModeEnums.READ) && (
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            aria-label="角色維護"
                            id="modalRoleListBtn"
                            onClick={onRoleList}
                        >
                            <svg className="btn__icon me-2" aria-hidden="true">
                                <use href="#ico-users-edit"></use>
                            </svg>
                            角色維護
                        </button>
                        )}
                        {this.checkPermission(ModuleEnums.ROLE_PERMISSION, AccessModeEnums.CREATE) && (
                        <button type="button" className="btn btn-sm btn-primary" aria-label="新增" id="modalRolePermBtnNew" onClick={onNewRolePermission}>
                            <svg className="btn__icon me-2" aria-hidden="true">
                                <use href="#ico-plus"></use>
                            </svg>
                            新增
                        </button>
                        )}
                    </div>
                </div>
                <div className="datatable__data" ref={this.tableRef}>
                    <table id="datatable__rolePermissionList" className="display table table-hover align-middle nowrap"></table>
                </div>
            </section>
        );
    }
}

RolePermissionPage.propTypes = {
};

RolePermissionPage.defaultProps = {
};

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RolePermissionPage);